<template>
  <icons-part />
  <header-part />
  <router-view class="main" />
  <footer-part @open-dialog="changelogVisible = true" />
  <change-logs :visible="changelogVisible" @close-dialog="changelogVisible = false" />
</template>

<script>
import HeaderPart from './components/parts/HeaderPart';
import FooterPart from './components/parts/FooterPart';
import IconsPart from './components/parts/IconsPart';
import ChangeLogs from './components/parts/ChangeLogs';

import version from '../version.js';
import { getMinorVersion } from './utils/helpers.js';

export default {
  components: {
    HeaderPart,
    FooterPart,
    IconsPart,
    ChangeLogs,
  },

  data() {
    return {
      changelogVisible: false,
    };
  },

  mounted() {
    let lastVer = localStorage.getItem('nsr-markup-version');

    if (!lastVer || getMinorVersion(version) !== getMinorVersion(lastVer)) {
      this.openChangeLogs();
      localStorage.setItem('nsr-markup-version', version);
    }
  },

  methods: {
    openChangeLogs() {
      this.changelogVisible = true;
    },
  },
};
</script>

<style>
@font-face {
  font-family: 'Noto Serif';
  font-weight: 400;
  font-style: normal;

  src:
    url('./assets/fonts/NotoSerif-Regular.woff2') format('woff2'),
    url('./assets/fonts/NotoSerif-Regular.woff') format('woff');
}

@font-face {
  font-family: 'Noto Serif';
  font-weight: 700;
  font-style: normal;

  src:
    url('./assets/fonts/NotoSerif-Bold.woff2') format('woff2'),
    url('./assets/fonts/NotoSerif-Bold.woff') format('woff');
}

@font-face {
  font-family: 'Noto Serif';
  font-weight: 400;
  font-style: italic;

  src:
    url('./assets/fonts/NotoSerif-Italic.woff2') format('woff2'),
    url('./assets/fonts/NotoSerif-Italic.woff') format('woff');
}

@font-face {
  font-family: 'Noto Serif';
  font-weight: 700;
  font-style: italic;

  src:
    url('./assets/fonts/NotoSerif-BoldItalic.woff2') format('woff2'),
    url('./assets/fonts/NotoSerif-BoldItalic.woff') format('woff');
}

*:not(.settings-form__row *, .spec-text__item__wrap *) {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
*::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0);
}
*::-webkit-scrollbar-thumb {
  background-color: #a2a8af;
  border-radius: 8px;
}
html {
  width: 100%;
  height: 100%;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  height: 100%;
  font-family: Roboto, Arial, sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
  width: 100%;
}
.doc-header,
.doc-content,
.doc-table {
  box-sizing: border-box;
  padding: 5px 10px;
  margin: 0;
  text-align: justify;
}
h1.doc-header {
  font-size: 1.2rem;
}
h2.doc-header {
  font-size: 1.15rem;
}
h3.doc-header {
  font-size: 1.1rem;
}
.doc-content {
  text-align: left;
}
table {
  border-collapse: collapse;
}
td,
th {
  padding: 0 10px;
}
.doc-table td {
  padding: 0.4em;
}
.el-date-table td,
.el-date-table th,
.el-month-table td,
.el-year-table td {
  border: none;
}
</style>
